import memoize from 'lodash.memoize';
import { useEffect, useState } from 'react';
import { getScript } from 'utils/getScript';

const GOOGLE_MAPS_SCRIPT =
  'https://maps.googleapis.com/maps/api/js?key=AIzaSyB_wv1Djbu3T7E1wYgE2zqJmkw7zxQvJrQ&libraries=places&language=en&callback=initMap';
declare const window: any;
function isMapsLoaded() {
  return window.googleMapsLoaded || false;
}

window.initMap = () => {
  window.googleMapsLoaded = true;
  console.log('google maps loaded');
};

const loadGoogleMaps = memoize(() => {
  console.log('loading google maps');
  return getScript(GOOGLE_MAPS_SCRIPT);
});

export default function useGoogleMaps() {
  const [isLoaded, setLoaded] = useState(isMapsLoaded());

  useEffect(() => {
    if (!isLoaded) {
      loadGoogleMaps().then(() => setLoaded(true));
    }
    return () => {};
  }, [isLoaded]);

  return isLoaded;
}
